<template>
    <!-- App Header -->
    <SideHeader :to="'/selectCities'" />
    <!-- * App Header -->

    <!-- App Capsule -->
    <div id="refresh-container">
        <div style="padding-top: 55px;">

            <!-- * App Header -->

            <Placeholder v-if="loading" />

            <div v-else style="background-color: white">
                <FixLimited v-if="freeCalls != 'false'" :freeCalls="freeCalls" />

                <div class="section" :class="[
                    { 'mt-3 mb-3': index !== 0 },
                    { 'mt-0 mb-3': index == 0 },
                    { 'pt-45': index == 0 }
                ]" v-for="(cargo, index) in cargos" :key="index.id">
                    <CardView :cargo="cargo" />
                </div>

                <button @click="nextLoadCargo()" class="btn btn-success btn-block btn-lg"
                    v-if="mode == 1 && loadingNext == 0">
                    نمایش بار های بیشتر کلیک کنید...
                </button>
                <button class="btn btn-warning btn-lg btn-block" type="button" disabled="" v-if="loadingNext == 1">
                    <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
                    درحال بارگذاری ...
                </button>
            </div>

            <a href="#" class="button goTop show">
                <ion-icon name="arrow-up-outline"></ion-icon>
            </a>
        </div>
    </div>

</template>
<script>
import Placeholder from "@/components/Placeholder.vue";
import CardView from "@/views/cargo/components/CardView.vue";
import axios from "axios";
import Swal from "sweetalert2";
import SideHeader from "@/components/SideHeader.vue";
import PullToRefresh from "pulltorefreshjs";
import router from "@/router";
import FixLimited from "@/components/FixLimited.vue";

export default {
    name: "showSearch",
    components: {
        CardView,
        Placeholder,
        SideHeader,
        FixLimited
        // Footer
    },
    data() {
        return {
            mode: 0,
            cargos: [],
            show: false,
            cities: {
                from: null,
                to: null
            },
            loading: false,
            loadingNext: 0,
            freeCalls: '',
            cityTo: [],
            cityFrom: [],
            ptrInstance: null,
            postData: {
                selectedLoadingCitiesIds: this.$route.query.selectedDischargeCitiesIds,
                selectedDischargeCitiesIds: this.$route.query.selectedLoadingCitiesIds,
                fleet_id: this.$route.query.fleet_id,
            },
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            }
        };
    },
    methods: {
        searchProvince() {
            this.loading = true;
            axios.post(
                `https://core.iran-tarabar.ir/api/requestCitiesList`,
                this.postData
            )
                .then((res) => {
                    this.cityTo = res.data.selectedLoadingCitiesIds.map((a) => a.id);
                    this.cityFrom = res.data.selectedDischargeCitiesIds.map((a) => a.id);
                    this.cityTo.forEach((element, index) => {
                        this.cityTo[index] = "\n  " + element;
                    });

                    this.cityFrom.forEach((element, index) => {
                        this.cityFrom[index] = "\n  " + element;
                    });
                    this.cities.from = JSON.stringify(this.cityFrom);
                    this.cities.to = JSON.stringify(this.cityTo);

                    axios.post(`https://core.iran-tarabar.ir/api/driver/searchLoadForDriver`,
                        {
                            selectedLoadingCitiesIds: this.cities.from,
                            selectedDischargeCitiesIds: this.cities.to,
                            fleet_id: this.postData.fleet_id,
                        },
                        this.axiosConfig
                    )
                        .then((response) => {
                            // console.log(response);
                            this.freeCalls = response.data.freeCalls;
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                            if (response.data.result == 0) {
                                Swal.fire({
                                    position: "center",
                                    icon: "error",
                                    title: response.data.message,
                                    showConfirmButton: true,
                                    confirmButtonText: "تایید",
                                    timer: 2000,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        window.history.go(-1);
                                        return false;
                                    }
                                });
                            } else {
                                response.data.loads.length == 25 ? this.mode = 1 : this.mode = 0;
                                this.loading = false;
                                this.cargos = response.data.loads;
                                setTimeout(() => {
                                    const savedPosition = localStorage.getItem('scrollPosition');
                                    window.scrollTo(0, savedPosition);
                                }, 100);
                                this.show = true;
                            }
                        }).catch((error) => {
                            if (error.response.status === 401) {
                                Swal.fire({
                                    title: "راننده محترم!",
                                    text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
                                    icon: "error",
                                    confirmButtonColor: "#068b80",
                                    confirmButtonText: "ورود مجدد!",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        localStorage.clear();
                                        router.push({ name: 'login' })
                                    }
                                });

                            }
                        });
                }).catch((error) => {
                    if (error.response.status === 401) {
                        Swal.fire({
                            title: "راننده محترم!",
                            text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
                            icon: "error",
                            confirmButtonColor: "#068b80",
                            confirmButtonText: "ورود مجدد!",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                localStorage.clear();
                                router.push({ name: 'login' })
                            }
                        });

                    }
                });
        },
        nextLoadCargo() {
            this.loadingNext = 1;
            axios.post(`https://core.iran-tarabar.ir/api/driver/searchLoadForDriver`,
                {
                    selectedLoadingCitiesIds: this.cities.from,
                    selectedDischargeCitiesIds: this.cities.to,
                    fleet_id: this.postData.fleet_id,
                    lastLoadId: this.cargos[this.cargos.length - 1].id,
                },
                this.axiosConfig
            )
                .then((response) => {

                    if (response.data.result == 0) {
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: response.data.message,
                            showConfirmButton: true,
                            confirmButtonText: "تایید",
                            // timer: 2000,
                        });
                    } else {
                        this.cargos.push(...response.data.loads);
                        this.loadingNext = 0;

                    }
                });
        },
        initPullToRefresh() {
            if (this.ptrInstance) {
                this.ptrInstance.destroy();
            }
            this.ptrInstance = PullToRefresh.init({
                mainElement: '#refresh-container',
                onRefresh: () => this.searchProvince()
            });
        },
        saveScrollPosition() {
            localStorage.setItem('scrollPosition', window.scrollY);
        },
    },
    beforeMount() {
        this.searchProvince();
    },
    mounted() {
        this.initPullToRefresh();
        // window.addEventListener('beforeunload', this.saveScrollPosition);

    },
    beforeRouteLeave(to, from, next) {
        this.saveScrollPosition();
        next();
    },
    beforeUnmount() {
        if (this.ptrInstance) {
            this.ptrInstance.destroy();
        }
    }
};
</script>
<style>
.pt-45 {
    padding-top: 2rem !important;
}

#webpack-dev-server-client-overlay {
    display: none;
}
</style>